// components/CustomQuestions.jsx
import React from "react";

const CustomQuestions = ({ questions, answers, onChange }) => {
  const renderQuestion = (question) => {
    const value = answers?.[question._id];

    switch (question.type) {
      case "boolean":
        return (
          <div className="custom-question-field boolean-field">
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name={`custom_${question._id}`}
                  value="yes"
                  checked={value === true}
                  onChange={() => onChange(question._id, true)}
                  required={question.required}
                />
                <span className="radio-label">Yes</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name={`custom_${question._id}`}
                  value="no"
                  checked={value === false}
                  onChange={() => onChange(question._id, false)}
                  required={question.required}
                />
                <span className="radio-label">No</span>
              </label>
            </div>
          </div>
        );

      case "select":
        return (
          <div className="custom-question-field select-field">
            <select
              className="custom-select"
              required={question.required}
              value={value || ""}
              onChange={(e) => onChange(question._id, e.target.value)}
            >
              <option value="">-- Select an option --</option>
              {question.options?.map((opt, idx) => (
                <option key={idx} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        );

      case "text":
      default:
        return (
          <div className="custom-question-field text-field">
            <textarea
              type="text"
              className="custom-textarea"
              required={question.required}
              value={value || ""}
              onChange={(e) => onChange(question._id, e.target.value)}
              placeholder="Type your answer here..."
            />
          </div>
        );
    }
  };

  return (
    <div className="custom-questions-section">
      <h3 className="section-title">Additional Questions</h3>
      <div className="custom-questions-container">
        {questions.map((question, index) => (
          <div className="form-group custom-question" key={question._id}>
            <label className="custom-question-label">
              <span className="question-number">{index + 1}.</span>
              <span className="question-text">{question.label}</span>
              {question.required && (
                <span className="required-asterisk"> *</span>
              )}
            </label>
            {renderQuestion(question)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomQuestions;
